module.exports = __webpack_public_path__ + "media/images/partners/afisha-5f91283b2fc3d09370fff5d409329bcc.svg";